import { EventEmitter, Injectable } from "@angular/core";
import { environment } from "src/environments/environment.prod";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { StaticPagesService } from "./static-pages.service";

@Injectable({
    providedIn: "root",
})
export class HomePageService {
    public categoriesDataSub = new BehaviorSubject([]);
    public initalData = new BehaviorSubject(null);
    public menuData = new Subject();
    public loadingEmit: EventEmitter<HomePageService>;
    public isInitLoading = new BehaviorSubject(false);
    environmentVariables:any
      
        constructor(private http: HttpClient ,  private confgServ: StaticPagesService, ) {
        this.loadingEmit = new EventEmitter();
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }

    /// ======= Get Home Page Data ======= ///
    getHomePageData() {
        return this.http
            .get<any>(`${environment.api}/api/customer/home2`)
            .pipe(map((data) => data));
    }

    getMenuData() {
        return this.http
            .get<any>(`${environment.api}/api/customer/home/menu`)
            .pipe(map((data) => data));
    }

    getHomeAdsData() {
        return this.http
            .get<any>(`${environment.api}/api/customer/home/ads`)
            .pipe(map((data) => data));
    }
    getHomePopupAdsData() {
        return this.http
            .get<any>(`${environment.api}/api/customer/home/popup-ads`)
            .pipe(map((data) => data));
    }
    getAllStores() {
        return this.http
            .get<any>(`${environment.api}/api/customer/v2/dropdown/branches`)
            .pipe(map((data) => data));
    }
    setStore(data: any) {
        return this.http
            .post<any>(
                `${environment.api}/api/customer/profile/set-branch`,
                data
            )
            .pipe(map((data) => data));
    }

    getHomeCustomAdsData() {
        return this.http
            .get<any>(`${environment.api}/api/customer/home/custom-ads`)
            .pipe(map((data) => data));
    }

    getHomeSectionsData(url:any) {
        return this.http
            .get<any>(`${environment.api}/api/customer/${url}`)
            .pipe(map((data) => data));
    }


      disable_category = localStorage.getItem('disable_category') ?? 1;
  getInitializationsData(initalData?: any) {
		if(initalData["query_params"]){
			if (+this.disable_category && this.environmentVariables.ENABLE_MULTI_INVENTORY) {
				initalData["query_params"]['disable_category'] = 1;
			   this.disable_category =  0; 
			   localStorage.setItem('disable_category' , '0')
			 } else {
				initalData["query_params"]['disable_category'] = 0;
			 }
		}
        return this.http.get(
            `${environment.api}/api/customer/home/initialize`,
            { params: initalData.query_params }
        );
         
    }

    getCategoriesWithProductsStock(){
        return this.http.get(
            `${environment.api}/api/customer/categories/in_stock_categories`) 
    }

    getCompareList() {
        return this.http.get(
            `${environment.api}/api/customer/products/comparisons`
        );
    }

    getProductDetails(ProductId: number) {
        return this.http.get(
            `${environment.api}/api/customer/products/${ProductId}`
        );
    }

    addToCompareList(productId: number) {
        return this.http.post(
            `${environment.api}/api/customer/products/set_compare/${productId}`,
            {}
        );
    }

    addProductsToCompareList(data: any) {
        return this.http.post(
            `${environment.api}/api/customer/products/set_products_compare`,
            data
        );
    }

    removeFromCompareList(productId: number) {
        return this.http.post(
            `${environment.api}/api/customer/products/remove_compare/${productId}`,
            {}
        );
    }

    setCompare(productId: number) {
        return this.http.post(
            `${environment.api}/api/customer/products/set_compare/${productId}`,
            {}
        );
    }

    getFavList() {
        return this.http.get(
            `${environment.api}/api/customer/products/favourites`
        );
    }

    addToFavList(variantId: number) {
        return this.http.post(
            `${environment.api}/api/customer/products/favourite/${variantId}`,
            {}
        );
    }

    addProductsToFavList(data: any) {
        return this.http.post(
            `${environment.api}/api/customer/products/add_products_favourite`,
            data
        );
    }

    removeFromFavList(variantId: number) {
        return this.http.post(
            `${environment.api}/api/customer/products/unfavourite/${variantId}`,
            {}
        );
    }
    setMenuData(data: any) {
        this.menuData.next(data);
    }
    getMenuDataa(): Observable<any> {
        return this.menuData.asObservable();
    }
    setInitData(data: any) {
        this.initalData.next(data);
    }
    getInitData(): Observable<any> {
        return this.initalData.asObservable();
    }
    setcategoriesDataSub(data: any) {
        this.categoriesDataSub.next(data);
        // this.categoriesDataSub.next(data)
        // localStorage.setItem('categoryMenu', JSON.stringify(data));
    }

    loadingCategoriesEmit(data: any) {
        this.loadingEmit.emit(data);
    }

    getSettings() {
        return this.http
            .get<any>(`${environment.api}/api/customer/settings`)
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    cloneGuestData(data: any) {
        return this.http.post(
            `${environment.api}/api/customer/clone-guest-products`,
            data
        );
    }
    /// =======  Subscribe API  ======= ///
    subscribeEmail(data: any) {
        return this.http
            .post<any>(`${environment.api}/api/customer/newsletter`, data)
            .pipe(
                map((mail) => {
                    return mail;
                })
            );
    }


    // getCategoriesSections(url:any){
    //      return this.http
    //         .get<any>(`${environment.api}/api/customer/v2/categories`)
    //         .pipe(map((data) => data));
    // }

    //     getHomeSectionsData1() {
    //     return this.http
    //         .get<any>(`${environment.api}/api/customer/home/sections`)
    //         .pipe(map((data) => data));
    // }
}
